import type { IconSvgProps } from "@modules/ui/components/huButtonIcon"

export const SwitchDeviceIcon: React.FC<IconSvgProps> = (props) => (
  <svg width="238" height="219" viewBox="0 0 238 219" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M46.8133 71.4875C75.937 20.9426 173.762 17.6362 196.189 71.4875C214.85 116.293 184.884 166.84 138.665 181.658C103.351 192.98 68.3374 187.756 46.8133 157.557C27.3046 130.186 30.0324 100.611 46.8133 71.4875Z"
      fill="#E6E6E6"
    />
    <path
      d="M179.609 92.8195L179.275 110.595L161.764 107.522L166.852 103.329C166.852 103.329 162.247 97.4707 158.015 96.0006C149.586 93.0719 152.947 101.322 152.947 101.322C152.947 101.322 148.567 96.9033 151.372 93.2584C154.342 89.3994 157.44 89.9849 159.842 89.9579C166.901 89.8785 174.521 97.0114 174.521 97.0114L179.609 92.8195Z"
      fill="url(#paint0_radial_15135_152835)"
    />
    <path
      d="M139.064 122.756L142.026 122.28L141.55 119.318L131.937 59.4885C130.746 52.0803 123.776 47.0398 116.368 48.2302L15.3918 64.4555C7.98359 65.6459 2.94306 72.6164 4.13345 80.0246L13.7471 139.854L14.223 142.816L17.185 142.34L139.064 122.756Z"
      fill="#121212"
    />
    <path
      d="M139.064 122.756L142.026 122.28L141.55 119.318L131.937 59.4885C130.746 52.0803 123.776 47.0398 116.368 48.2302L15.3918 64.4555C7.98359 65.6459 2.94306 72.6164 4.13345 80.0246L13.7471 139.854L14.223 142.816L17.185 142.34L139.064 122.756Z"
      stroke="#DDF247"
      strokeWidth="6"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.95739 78.6895C6.10611 73.3916 9.71074 68.4068 15.0085 67.5556L118.093 50.9914C123.391 50.1401 128.376 53.7447 129.227 59.0425L139.015 119.956L16.7453 139.603L6.95739 78.6895ZM75.3664 59.4441L118.342 52.5386C122.785 51.8246 126.966 54.8478 127.68 59.2911L137.219 118.658L18.0439 137.807L8.50457 78.4408C7.7906 73.9975 10.8138 69.8167 15.2572 69.1027L58.2326 62.1972L58.2897 62.5526C58.4819 63.7489 59.6075 64.5628 60.8038 64.3706L73.6055 62.3136C74.8018 62.1213 75.6157 60.9957 75.4235 59.7995L75.3664 59.4441Z"
      fill="#DDF247"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M68.9629 85.3804L66.4659 92.7449L78.9028 90.7461L82.0159 81.5644C82.16 81.1393 81.7959 80.7174 81.3473 80.7895L72.7986 82.1633C71.0146 82.4501 69.5359 83.6902 68.9629 85.3804ZM65.1014 98.1445L61.9883 107.326C61.8441 107.751 62.2082 108.173 62.6569 108.101L71.2055 106.727C72.9895 106.441 74.4682 105.2 75.0413 103.51L77.5383 96.1458L65.1014 98.1445Z"
      fill="white"
    />
    <rect
      x="8.12845"
      y="142.426"
      width="139.175"
      height="12"
      rx="6"
      transform="rotate(-9.12853 8.12845 142.426)"
      fill="#121212"
      stroke="#DDF247"
      strokeWidth="6"
    />
    <rect
      x="195.395"
      y="105.87"
      width="44.2263"
      height="72.896"
      rx="8"
      transform="rotate(21.1061 195.395 105.87)"
      fill="#121212"
      stroke="#DDF247"
      strokeWidth="6"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M204.042 142.763L200.804 145.483L207.151 148.062L211.189 144.67C211.376 144.513 211.326 144.215 211.097 144.122L206.734 142.349C205.823 141.979 204.786 142.139 204.042 142.763ZM198.646 147.61L194.609 151.001C194.422 151.158 194.472 151.457 194.701 151.55L199.064 153.323C199.974 153.693 201.012 153.533 201.755 152.909L204.994 150.188L198.646 147.61Z"
      fill="white"
    />
    <defs>
      <radialGradient
        id="paint0_radial_15135_152835"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(179.124 99.0714) rotate(-178.186) scale(35.581 29.4239)"
      >
        <stop offset="0.413589" stopColor="#121212" />
        <stop offset="0.420362" stopColor="#454643" />
      </radialGradient>
    </defs>
  </svg>
)
